import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import styles from "../../cards.module.scss"

function HighlightItem({ highlight, handleClickHighlight, handleDuplicateHighlight, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickHighlight}>
      <img
        className={styles.projectImage}
        src={highlight.image ? highlight.image.file : getImage('img-ph.png')}
        alt={highlight.image ? highlight.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{highlight.title}</p>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('shared.draftTypes', highlight.is_draft).label,
              bgColor: getConstant('shared.draftTypes', highlight.is_draft).bgColor
            }}
          />
          <Tag
            tag={{
              label: getConstant('quatrebis.highlightType', highlight.type).label,
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className={styles.button}
        tooltip="Dupliquer le temps fort / Alumni"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateHighlight}
        severity="secondary"
        outlined
      />
    </div>


  );
}

export default HighlightItem;
